import React, { useCallback, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Avatar, Popover, Skeleton, Stack, Tooltip } from '@mui/material'
import { Business as BusinessIcon } from '@mui/icons-material'
import { getImageUrl } from 'services/assets'
import { CHURN_ZERO_EVENTS, DEFAULT_SUPPLIER_TYPES } from 'utils/constants'
import { trackEvent } from 'utils/tracking'

const LicenseAvatar = ({ selectedCustomer, customerData }) => {
  const [imageUrl, setImageUrl] = useState(null)
  const eventName = CHURN_ZERO_EVENTS.GET_S3_IMAGE

  const handleS3Error = useCallback(
    error => {
      const errorMsg = error?.data?.error || 'There was an error getting the image'
      trackEvent({ eventName, errorMsg })
    },
    [eventName],
  )

  useEffect(() => {
    if (customerData?.contacts?.[0]?.licenseImage) {
      getImageUrl(customerData?.contacts?.[0]?.licenseImage)
        .then(url => {
          setImageUrl(url)
        })
        .catch(handleS3Error)
    }
  }, [customerData?.contacts, handleS3Error])

  const [licenseAnchorEl, setLicenseAnchorEl] = useState(false)

  return selectedCustomer?.id === customerData?.id ? (
    <>
      {customerData?.supplierType !== DEFAULT_SUPPLIER_TYPES.INDUSTRIAL &&
        customerData?.contacts?.[0]?.licenseImage && (
          <>
            <Avatar
              src={imageUrl}
              variant="rounded"
              onClick={event => {
                event.stopPropagation()
                setLicenseAnchorEl(event.target)
              }}
              sx={{
                cursor: 'pointer',
                '& *': {
                  cursor: 'pointer',
                },
              }}
            />
            <Popover
              open={!!licenseAnchorEl}
              anchorEl={licenseAnchorEl}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              transformOrigin={{
                vertical: 'center',
                horizontal: 'left',
              }}
              onClose={event => {
                event.stopPropagation()
                setLicenseAnchorEl(null)
              }}
            >
              <Stack>
                <img src={imageUrl} alt="" height={160} />
              </Stack>
            </Popover>
          </>
        )}
      {customerData?.supplierType !== DEFAULT_SUPPLIER_TYPES.INDUSTRIAL &&
        !customerData?.contacts?.[0]?.licenseImage && (
          <>
            <Tooltip title="Customer has no license on file." placement="top" arrow>
              <Avatar src="" variant="rounded" />
            </Tooltip>
          </>
        )}
      {customerData?.supplierType === DEFAULT_SUPPLIER_TYPES.INDUSTRIAL && (
        <Avatar variant="rounded">
          <BusinessIcon />
        </Avatar>
      )}
    </>
  ) : (
    <Skeleton sx={{ minWidth: '40px', minHeight: '40px', transform: 'none' }} animation="wave">
      <Avatar />
    </Skeleton>
  )
}

LicenseAvatar.propTypes = {
  selectedCustomer: PropTypes.object,
  customerData: PropTypes.object,
}

LicenseAvatar.defaultProps = {
  selectedCustomer: {},
  customerData: {},
}

export default LicenseAvatar
